import * as React from 'react';

import { Container, Row, Col } from 'react-bootstrap';
import FooterItem from './FooterItem';
import '../Assets/Footer.sass';
const bodhitree_icon = "/images/Bodhilogo.svg";
import * as constants from 'Constants';
import { useVersion } from 'hooks/useVersion';

const Footer = () => {
    const { tag, commitHash } = useVersion();

    return (
        <Container fluid className="m-0 p-0 footer-container d-flex flex-column">
            <Row className="m-0 px-1 px-md-5 py-1 py-md-3">
                <Col className="px-0 mb-0">
                    <img
                        className="d-inline-block align-top"
                        src={bodhitree_icon}
                        alt="Bodhitree Logo"
                        style={{ width: "125px", height: "auto" }}
                    />
                </Col>
                <Col className="px-0 d-flex justify-content-between align-items-center">
                    <FooterItem url='/terms' childComp={"Terms Of Use"} />
                    <FooterItem url='/privacy' childComp={"Privacy Policy"} />
                    {/* <FooterItem url='#' childComp={<img src={'/Screens_old/Layout/Common/Assets/googlePlay.png'} />} /> */}
                    <FooterItem url='/contactUs' childComp={"Contact Us"} />
                    {/* <FooterItem url='#' childComp={"About Us"} /> */}
                </Col>
            </Row>
            <Container fluid className="d-flex justify-content-center align-items-center">
                <p className="m-0 py-1" style={{ color: "#757589", fontSize: "14px", fontFamily: "poppins" }}>
                    Copyright @ 2024 Bodhitree, All Rights Reserved  |  {tag}
                    {commitHash && ` | ${commitHash}`}
                    &nbsp;
                    <a
                        href={`${constants.base_url}/version/`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="View full version details (commit, tag, last refreshed)"
                        aria-label="View full version details"
                        style={{
                            display: "inline-block",
                            width: "15px",
                            height: "15px",
                            lineHeight: "13px",
                            border: "1px solid #757589",
                            borderRadius: "50%",
                            color: "#757589",
                            fontSize: "11px",
                            fontStyle: "italic",
                            fontWeight: "bold",
                            textAlign: "center",
                            textDecoration: "none",
                            verticalAlign: "middle",
                        }}
                    >
                        i
                    </a>
                </p>
            </Container>
        </Container>
    );
};

export default Footer;
